import { classNameMerger } from '@breetometer/utils';

import type { WithdrawRequestFiatInputProps } from '../../FiatInput.helpers';
import { FiatInputErrorComponent } from '../Error';
import { FiatInputComponent } from '../Input';
import { FiatInputLabel } from '../Label';
import { FiatInputMaxComponent } from '../Max';
import { FiatInputTooltip } from '../Tooltip';

const WithdrawRequestFiatInput = ({
	id,
	value,
	label,
	errorMessage,
	message,
	handleMaxClick,
	hideTooltip,
	wrapperClass,
	...rest
}: WithdrawRequestFiatInputProps) => (
	<div className={classNameMerger('fiat_input', wrapperClass)}>
		<FiatInputTooltip
			hideTooltip={hideTooltip}
			value={value}
		/>

		<div className='fiat_input_wrapper bg-primary-500 withdraw-request'>
			<FiatInputLabel
				id={id}
				label={label}
			/>

			<div className='fiat_input_component_wrapper'>
				<FiatInputComponent
					{...rest}
					value={value}
				/>

				<FiatInputMaxComponent
					isMaxFeat={typeof handleMaxClick === 'function'}
					handleMaxClick={handleMaxClick}
				/>
			</div>
		</div>

		<FiatInputErrorComponent
			errorMessage={errorMessage}
			message={message}
		/>
	</div>
);

export default WithdrawRequestFiatInput;
